import * as actions from '../../actions/actionTypes';
//
const initialState = [];
//
export default function channelChannelView(state = initialState, action) {
  switch (action.type) {
    case actions.SET_CHANNEL_CHANNEL_VIEW:
      console.log('channelChannelView 실행', action.payload.list);
      if (action.payload.list) {
        return action.payload.list;
      } else {
        return state;
      }
    default:
      return state;
  }
}
